import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import MainHeader from "@/widgets/mainHeader/components/MainHeader";
import SideBar from "@/widgets/sideBar/components/SideBar";
// import { v4 as uuidv4 } from "uuid";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import useToastStore from "../zustand/toastStore";
import { Sidebar } from "primereact/sidebar";
import { X } from "lucide-react";
import useProjectStore from "../zustand/projectManagementStore";
import { useNavigate } from "react-router-dom";
import { defaultNameForManualSelection, HOST_MODES, modesToAssisstantName, selectModeAuto } from "@/constants";
import { useMainLayoutStore } from "../zustand/mainLayoutStore";
import { useHostMicroFrontendApi } from "../microfrontend/hooks/useHostMicroFrontend";
import { MF_EVENTS, } from "../microfrontend/interfaces/microFrontend";
import LearningSidebarContainer from "@/components/LearningSidebarContainer";
import { getModes } from "../utils/appLayoutUtils/appLayoutUtilities";
import { setupNetworkMonitoring } from "@/core/api/api.Interceptors";
// import { useEffect, useState } from "react";
import NotFoundAnimation from "@/assets/animations/notfoundAnimation.json";
import Lottie from "react-lottie-player";
const MainLayout = ({ triggerInstantLearningToMode, children, shallShowInstantLearningBtn, }) => {
    const toastRef = useRef(null);
    const mainParentRef = useRef(null);
    const feedbackParentRef = useRef(null);
    // const chatIdRef = useRef<string | undefined>(undefined);
    const navigate = useNavigate();
    const { showSidebar, showChatInterface, currentHostMode, modesHistory, showModeOnboarding, activeMode, modeList, setShowSidebar, setModesHistory, setCurrentHostMode, 
    // addModeHistory,
    setShowModeOnboarding, setActiveMode, setModeList, setSidebarType, setManualSelectionData } = useMainLayoutStore();
    const setToastRef = useToastStore((state) => state.setToastRef);
    const { setShowForm } = useProjectStore();
    const showToast = useToastStore((state) => state.showToast);
    const mfApi = useHostMicroFrontendApi();
    const [feedbackData, setFeedbackData] = useState(() => {
        if (modesHistory.length > 0) {
            if (modesHistory[modesHistory.length - 1]?.mode) {
                const currentMode = modesHistory[modesHistory.length - 1].mode;
                const initialAssistantName = currentMode
                    ? modesToAssisstantName[currentMode]
                    : "";
                return {
                    feedbackData: {
                        originalContent: "",
                        suggestedReplacement: "",
                        applyTo: currentMode || "",
                        whenToApply: "",
                        whenNotToApply: "",
                    },
                    modeAssistantName: initialAssistantName,
                    modeName: currentMode || "",
                };
            }
        }
        // Default return value for when conditions are not met
        return {
            feedbackData: {
                originalContent: "",
                suggestedReplacement: "",
                applyTo: "",
                whenToApply: "",
                whenNotToApply: "",
            },
            modeAssistantName: "",
            modeName: "",
        };
    });
    const [instantLearningData, setInstantLearningData] = useState(null);
    // Update feedbackData when activeMode changes
    // useEffect(() => {
    //   if (activeMode) {
    //     const assistantName = modesToAssisstantName[activeMode];
    //     setFeedbackData((prev) => ({
    //       ...prev,
    //       modeAssistantName: assistantName || "",
    //       modeName: activeMode,
    //       feedbackData: {
    //         ...prev.feedbackData,
    //         applyTo: activeMode,
    //       },
    //     }));
    //   }
    // }, [activeMode]);
    // Update effect that responds to changes in modesHistory
    useEffect(() => {
        const lastMode = modesHistory.length > 0 && modesHistory[modesHistory.length - 1]?.mode
            ? modesHistory[modesHistory.length - 1].mode
            : "";
        if (lastMode.length > 0) {
            const assistantName = modesToAssisstantName[lastMode] || "";
            setFeedbackData((prev) => ({
                ...prev,
                modeAssistantName: assistantName,
                modeName: lastMode,
                feedbackData: {
                    ...prev.feedbackData,
                    applyTo: lastMode,
                },
            }));
        }
    }, [modesHistory]); // Now depends on modesHistory instead of activeMode
    useEffect(() => {
        setToastRef(toastRef);
    }, [setToastRef]);
    useEffect(() => {
        const fetchModes = async () => {
            const resultList = await getModes();
            if (resultList && resultList.length > 0)
                setModeList(resultList);
        };
        fetchModes();
    }, []);
    const handleModeSelectFrom = (mode, by, isHost, isEmpty) => {
        // console.log("called handleModeSelectFrom", {mode, by, isHost, isEmpty});
        // normal case 
        if (by !== defaultNameForManualSelection) {
            console.log("by is not user manually done and its generic case", { by, mode });
            if (isHost)
                setCurrentHostMode(mode);
            else
                setActiveMode(mode);
        }
        // here if by is user manually done && mode is not auto mode, then manualSelection = true; and change the RHS
        // else if user manually done && mode is auto mode, then manualSelection = false; and dont change the RHS
        else if (by === defaultNameForManualSelection && mode !== selectModeAuto) {
            console.log("by is user manually done && mode is not auto mode", { by, mode });
            setManualSelectionData({
                isSelected: true,
                modeName: mode
            });
            // to change the RHS
            if (isHost)
                setCurrentHostMode(mode);
            else
                setActiveMode(mode);
        }
        else if (by === defaultNameForManualSelection && mode === selectModeAuto) {
            console.log("by is user manually done && mode is auto mode", { by, mode });
            setManualSelectionData({
                isSelected: false,
                modeName: ""
            });
        }
        // if (isHost) setCurrentHostMode(mode);
        // else setActiveMode(mode);
        if (isEmpty) {
            console.warn("there is an empty mode added by ", by);
        }
        setModesHistory((prev) => [
            ...prev,
            {
                mode: mode,
                openedBy: by,
            },
        ]);
    };
    const handleNewChatBtn = () => {
        window.location.href = "/chat?newChat=true"; // should be redirected to new chat :)
    };
    const handleNewProject = () => {
        if (location.pathname === "/settings") {
            navigate("/chat");
        }
        setCurrentHostMode(HOST_MODES["Project Mode"]);
        setModesHistory([
            {
                mode: HOST_MODES["Project Mode"],
                openedBy: "Sidebar",
            },
        ]);
        setShowSidebar(false);
        setShowForm(true);
    };
    // initializing microfrontend
    useEffect(() => {
        const handleRemoteLoad = () => {
            console.log("Sidebar feedback loaded successfully");
            // old code
            // setIsHostLoaded?.(true);
            // setHostLoadedInfo({
            //   modeName: HOST_MODES['Project Mode'],
            //   isLoaded: true
            // })
            if (mfApi && "setRemoteLoaded" in mfApi) {
                mfApi.setRemoteLoaded(true);
            }
        };
        const handleRemoteUnload = () => {
            console.log("Sidebar feedback unloaded");
            // setHostLoadedInfo({
            //   modeName: HOST_MODES['Project Mode'],
            //   isLoaded: false
            // })
            // old code
            // setIsHostLoaded?.(false);
            if (mfApi && "setRemoteLoaded" in mfApi) {
                mfApi.setRemoteLoaded(false);
            }
        };
        handleRemoteLoad();
        return () => {
            handleRemoteUnload();
        };
    }, [mfApi]);
    // listening to microfrontend events
    useEffect(() => {
        if (!mfApi) {
            console.warn("Remote MicroFrontend API not initialized");
            return;
        }
        const unsubscribers = [];
        const feedbackStatusUnsubscribe = mfApi.subscribe(MF_EVENTS.FEEDBACK_STATUS, (request) => {
            console.log("Host Feedback Side bar feedback received request:", request);
            setFeedbackData(request);
            setSidebarType("feedback");
        });
        unsubscribers.push(feedbackStatusUnsubscribe);
        const instantLearningStatusUnsubscribe = mfApi.subscribe(MF_EVENTS.INSTANT_LEARNING_STATUS, (data) => {
            console.log("Host Instant Side bar instant learning received data:", data);
            setInstantLearningData(data);
            // force update to react to the change as its asynchronus call; reason both setSidebarType updates are called once and 'feedback' is winning
            setTimeout(() => {
                setSidebarType("instant-learning");
            }, 0);
        });
        unsubscribers.push(instantLearningStatusUnsubscribe);
        return () => {
            unsubscribers.forEach((unsubscribe) => unsubscribe());
        };
    }, []);
    const [isOnline, setIsOnline] = useState(navigator.onLine);
    useEffect(() => {
        // Set up network monitoring
        const cleanup = setupNetworkMonitoring(() => {
            setIsOnline(false);
            showToast("warn", "Warning", "You are offline");
            // Show offline notification
        }, () => {
            setIsOnline(true);
            window.location.reload();
            showToast("success", "Success", "You are back online");
            // Show back online notification
        });
        return cleanup;
    }, []);
    return (_jsxs("div", { className: "flex flex-col w-full h-screen font-content", ref: mainParentRef, children: [_jsx(Toast, { ref: toastRef }), _jsx("div", { className: "w-full h-20", children: _jsx(MainHeader, { modesHistory: modesHistory, activeMode: activeMode, selectActiveMode: handleModeSelectFrom, modeList: modeList, setShowSidebar: setShowSidebar, triggerInstantLearningToMode: triggerInstantLearningToMode, shallShowInstantLearningBtn: shallShowInstantLearningBtn }) }), isOnline ? (_jsxs("div", { className: "w-full h-[calc(100%-5rem)] relative", ref: feedbackParentRef, children: [children, _jsx(LearningSidebarContainer, { feedbackData: feedbackData, instantLearningData: instantLearningData, feedbackParentRef: feedbackParentRef })] })) : (_jsxs("div", { className: "w-full h-full flex flex-col justify-center items-center gap-y-4", children: [_jsx(Lottie, { animationData: NotFoundAnimation, loop: true, play: true, className: "max-w-full w-72 mx-auto" }), _jsx("span", { className: " font-semibold text-2xl font-heading", children: "You are offline" })] })), _jsx(Sidebar, { visible: showSidebar, onHide: () => setShowSidebar(false), closeOnEscape: true, modal: false, position: "right", className: "w-[275px] border-l border-[#E5E7EB] shadow-md", closeIcon: _jsx(_Fragment, {}), showCloseIcon: false, header: _jsx("div", { className: "flex justify-end items-start w-full pt-2 px-7", children: _jsx(Button, { icon: _jsx(X, { size: 20 }), title: "Click to close sidebar", className: `w-10 h-10 cursor-pointer border border-[#D1D5DB] ${showChatInterface ? "bg-[#F9FAFB]" : "bg-[#fff]"} rounded-[6px] p-2`, onClick: () => setShowSidebar(false) }) }), children: _jsx(SideBar, { activeHostMode: currentHostMode, modesHistory: modesHistory, showModeOnboarding: showModeOnboarding, setShowModeOnboarding: setShowModeOnboarding, setCurrentHostMode: setCurrentHostMode, selectActiveMode: handleModeSelectFrom, openNewProject: handleNewProject, openNewChat: handleNewChatBtn }) })] }));
};
export default MainLayout;
